"use client";
import { ReactNode } from "react";
import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalAnimatedContent.module.scss";

interface ModalAnimatedContentProps {
  children: ReactNode;
}

/** Wrap the visual panel; keep fixed controls outside its scaling transform. */
export const ModalAnimatedContent = ({
  children,
}: ModalAnimatedContentProps) => {
  const { state, animation, contentReady } = useModal();

  return (
    <div
      className={styles["modal-animated-content"]}
      data-state={state}
      data-animation={animation}
      data-ready={contentReady}
    >
      {children}
    </div>
  );
};
